// extracted by mini-css-extract-plugin
module.exports = {"asosFocus":"_6DZZlcW","link":"_24SZgSx _6DZZlcW"};